import React, { useState, useEffect } from "react";
import { useNavigate, Link } from "react-router-dom";
import api, { formatApiErrorDetail } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import AuthShell, { authInput } from "@/pages/AuthShell";
import { Loader2 } from "lucide-react";

export default function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { setSession, user } = useAuth();
  const nav = useNavigate();

  useEffect(() => { if (user && user.id) nav(user.must_change_password ? "/change-password" : (user.role === "admin" ? "/portal/admin" : "/portal")); }, [user, nav]);

  const submit = async (e) => {
    e.preventDefault();
    setError(""); setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setSession(data);
      if (data.user.must_change_password) nav("/change-password");
      else nav(data.user.role === "admin" ? "/portal/admin" : "/portal");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
      setLoading(false);
    }
  };

  return (
    <AuthShell
      eyebrow="Member Login"
      title="Welcome back"
      footer={<>Forgot your password? <Link to="/forgot-password" style={{ color: "#2038E6" }} data-testid="forgot-link">Reset it</Link></>}
    >
      <form onSubmit={submit} style={{ display: "flex", flexDirection: "column", gap: 14 }}>
        <input data-testid="login-email" type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} style={authInput} />
        <input data-testid="login-password" type="password" placeholder="Password" value={password} onChange={(e) => setPassword(e.target.value)} style={authInput} />
        {error && <span style={{ color: "#b00020", fontSize: 14 }} data-testid="login-error">{error}</span>}
        <button className="btn-cobalt" type="submit" disabled={loading} data-testid="login-submit" style={{ justifyContent: "center" }}>
          {loading ? <Loader2 size={18} className="animate-spin" /> : "Log in"}
        </button>
      </form>
    </AuthShell>
  );
}
